"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { ClientErrorBoundary } from "@/components/error/ClientErrorBoundary";
import { TranslationFallbackBoundary } from "@/components/error/TranslationFallbackBoundary";
import { InactivityController } from "@/components/inactivity/InactivityController";
import { InactivityCrashLogout } from "@/components/inactivity/InactivityCrashLogout";
import { GlobalDataProvider } from "@/providers";

export default function ProtectedLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <GlobalDataProvider>
      {/* A crashed idle timer can't sign anyone out, so fail closed: the
          fallback logs the user out instead of offering Retry — but only when
          idle logout would be running (same enabled predicate as the timer:
          kill switch, test env, authenticated). A repeat crash within 10
          minutes of a crash logout is reported instead of logging out again,
          so a crash on every render cannot become a sign-in loop. */}
      <ClientErrorBoundary fallback={<InactivityCrashLogout />}>
        <InactivityController />
      </ClientErrorBoundary>
      <TranslationFallbackBoundary>{children}</TranslationFallbackBoundary>
    </GlobalDataProvider>
  );
}
